import React from 'react';

import { Helpers } from '../../core/src/helpers';
import { VisIDFacet } from '../../vwa/components/vwa-facet';
import Reviews from '@hpi-sox/hpstellar-core/visId/Reviews';
import { useAccordionContext } from '@hpi-sox/hpstellar-core/visId/Accordion';

// Removes '& Up' text. This can't be done on the HawkSearch/ETR side.
const parseRatingFilters = label => (typeof label === 'string' ? label.replace(/& Up/gi, '').trim() : label);
const parseRatingFiltersVisId = label => {
    try{
        const ratingNum = Number(label.match(/\d+/)[0])
        if(!isNaN(ratingNum)){
            return <Reviews score={ratingNum} reviewsLabel=" "/>
        } 
    }catch(e){}

    return <span dangerouslySetInnerHTML={Helpers.createMarkup(parseRatingFilters(label))} />
}

// TODO: Figure out why the new GFE Accordion disables this Facet without disabled=false
export default ({ label, ...rest }) => {
    return <VisIDFacet {...rest} label={parseRatingFiltersVisId(label)} alwaysEnabled/>
};
